<template>
  <div>
    <navbar></navbar>
    <!--START HOME-->
    <section class="section bg-home home-half" id="home" style="background-size: cover;background-position: center;">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-white text-center">
            <!--
      <h4 class="home-small-title">管理工具</h4>
      <h1 class="home-small-title">演示视频</h1>
      <p class="home-small-title">
        只展示部分内容.
      </p>
      -->
            <div class="video-container">
              <video autoplay loop muted>
                <source src="https://wty.scumdxs.cn/bbg.mp4" type="video/mp4">
                您的浏览器不支持video标签.
              </video>
              <div class="video-container">
                <video autoplay loop muted>
                  <source src="https://wty.scumdxs.cn/bbg.mp4" type="video/mp4">
                  您的浏览器不支持video标签.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-sm bg-light">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <div class="client-images my-3 my-md-0">
              <audio controls autoplay loop>
                <source src="https://example.com/path/to/unstoppable.mp3" type="audio/mpeg" />
              </audio>
            </div>
          </div>
          <!--
          <div class="col-md-3">
            <div class="client-images my-3 my-md-0">
              <img src="@/assets/images/clients/2.png" alt="logo-img" class="mx-auto img-fluid d-block" />
            </div>
          </div>
          -->
          <!-- 图片轮播 -->
          <div class="carousel-container">
            <ul class="img-carousel">
              <li v-for="(src, index) in imageSources" :key="index" :class="{ active: index === currentIndex }">
                <img :src="require('@/assets/img/' + src)" alt="">
              </li>
            </ul>
            <!-- 轮播控制 -->
            <button @click="prevImage" class="carousel-control prev">&lt;</button>
            <button @click="nextImage" class="carousel-control next">&gt;</button>
          </div>
        </div>
      </div>
    </section>
    <Features />
    <Services />
    <About />
    <Pricing />
    <Testimonial />
    <GetStarted />
    <Blog />
    <Contact />
    <Footer />
    <Switcher />
  </div>
</template>

<script>
import Navbar from "@/components/index111";
import Switcher from "@/components/switcher";

// Make sure to import other components like Features, Services, etc., if they are used in the template.

export default {
  components: {
    Navbar,
    Switcher,
    // Features, Services, etc.
  },
  data() {
    return {
      imageSources: [
        'A1 (1).jpg',
        'A1 (2).jpg',
        'A1 (3).jpg',
        'A1 (4).jpg',
        'A1 (5).jpg',
        'A1 (6).jpg',
        'A1 (7).jpg',
        'A1 (8).jpg',
        'A1 (9).jpg',
      ],
      currentIndex: 0,
      interval: null,
    };
  },
  mounted() {
    this.startImageRotation();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    startImageRotation() {
      this.interval = setInterval(this.nextImage, 5000); // 每3秒轮播一次图片
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.imageSources.length; // 切换到下一张图片
    },
    prevImage() {
      this.currentIndex = this.currentIndex === 0 ? this.imageSources.length - 1 : this.currentIndex - 1; // 切换到上一张图片
    }
  }
};
</script>
<style scoped>
.music-control {
  position: absolute;
  top: 30px;
  right: 40px;
}

.music-control img {
  height: 30px;
  width: 30px;
  opacity: 0.8;
}

.row {
  display: flex;
  justify-content: center;
}

.home-small-title {
  display: inline-block;
  margin: 0 10px;
  position: relative;
  top: -135px;
}

::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

::v-deep .modal-header {
  border: none;
}

/*.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  } */
.video-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 220px;
  /* 设置容器的高度*/
}

.video-container video {
  width: 50%;
  width: 400px;
  /*设置视频的宽度 */
  height: 300px;
  /* 设置视频的高度 */
}

::v-deep .modal-backdrop {
  opacity: 0.5;
}

.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.img-carousel {
  display: flex;
  transition: transform 0.3s ease-in-out;
}


.img-carousel li.active {
  display: block;
  /* 只显示激活状态的图片 */
}

.img-carousel li:not(.active) {
  display: none;
  /* 隐藏非激活状态的图片 */
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(49, 187, 7, 0.5);
  border: none;
  color: white;
  padding: 10px;
  cursor: pointer;
}

.carousel-control.prev {
  left: 10px;
}

.img-carousel img {
  display: block;
  max-width: 100%;
  /* 限制图片的最大宽度为父元素宽度的50% */
  height: auto;
  /* 设置高度为auto以保持图片的原始宽高比 */
  margin-left: auto;
  /* 左边距设置为自动，以便与右边距相等 */
  margin-right: auto;
  /* 右边距设置为自动，以便与左边距相等 */
}

.carousel-control.next {
  right: 10px;
}
</style>

